export default "__VITE_ASSET__CT_8MHX2__"